import { useMemo } from 'react';
import { FormSection } from 'redux-form';

import { zones as zonesService } from 'services/zones';
import { ZonesTabs } from '../blocks/zones-tabs';
import { DailyTariffication } from './daily-tariffication';
import { Content } from './daily.styled';

export const TarrificatorDaily = (props) => {
  const { selectedZone, setZone, disabled } = props;
  const zones = useMemo(() => zonesService.getZones(), []);

  /**
   * return current zone visual
   *
   * @memberof TarrificatorMenskings
   */
  const getTabs = () => {
    if (!selectedZone) {
      return null;
    }

    return zones.map((zone) => {
      return (
        <FormSection key={zone.id} name={zone.id}>
          <DailyTariffication color={zone.background_color} display={selectedZone === zone.id} name={zone.id} disabled={disabled} />
        </FormSection>
      );
    });
  };

  const tabsEl = getTabs();

  return (
    <Content>
      <ZonesTabs setZone={setZone} activeZone={selectedZone} />
      {tabsEl}
    </Content>
  );
};
